var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-data-table", {
    staticClass: "secondarybackground striped-table ma-2",
    attrs: {
      dense: "",
      "hide-default-footer": "",
      "fixed-header": "",
      "disable-sort": "",
      "disable-pagination": "",
      items: _vm.data,
      headers: _vm.headers
    },
    scopedSlots: _vm._u([
      {
        key: "item.id",
        fn: function({ item }) {
          return [_c("copy-to-clipboard", { attrs: { message: item.id } })]
        }
      },
      {
        key: "item.signalisation_datetime",
        fn: function({ item }) {
          return [
            _c("div", [
              _vm._v(
                "\n      " +
                  _vm._s(_vm._f("showDate")(item.signalisation_datetime)) +
                  "\n    "
              )
            ])
          ]
        }
      },
      {
        key: "item.customer_comment",
        fn: function({ item }) {
          return [
            _c("copy-to-clipboard", {
              attrs: {
                message: _vm._f("showComment")(item),
                "text-truncate-lenght": 60
              }
            })
          ]
        }
      },
      {
        key: "item.status",
        fn: function({ item }) {
          return [
            _c("div", [
              _vm._v("\n      " + _vm._s(_vm._f("showStatus")(item)) + "\n    ")
            ])
          ]
        }
      },
      {
        key: "item.technician_fullname",
        fn: function({ item }) {
          return [
            item.technician_fullname
              ? _c("div", [
                  _vm._v(
                    "\n      " +
                      _vm._s(item.technician_fullname) +
                      " (" +
                      _vm._s(item.technician_phone) +
                      ")\n    "
                  )
                ])
              : _vm._e()
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }